// extracted by mini-css-extract-plugin
export default {"shadowTop":"NoGroupTable_shadowTop__WxEP+","placeHolderShimmer":"NoGroupTable_placeHolderShimmer__bKYuI"};